import { Component, ElementRef, Injector, Type, ViewChild } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxBaseBlotterContextMenu } from "../../../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { animate, state, style, transition, trigger } from "@angular/animations";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  BenchmarkDataPrimaryLookupService,
  BfxBlotterAction,
  BfxBlotterOrdersContextMenuItem,
  HedgeOrderDataPrimaryLookupService,
} from "shared/cubiq-services";
import { NativeDesktopSupport } from "../../../bfx-native-desktop/native-desktop-support";
import { BmarkSpotRiskContextMenuService } from "./services/bmark-spot-risk-context-menu.service";
import {
  BmarkSpotRiskTraderGroupsMenuComponent,
  SelectedTraderGroupEvent,
} from "./bmark-spot-risk-tradergroups-menu.component";
import { BmarkSummaryContainerComponent } from "../../bmark-summary-container.component";

@Component({
  selector: "bmark-spot-risk-context-menu",
  templateUrl: "./html/bmark-spot-risk-context-menu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BmarkSpotRiskContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  @ViewChild("tgMenu", {
    read: BmarkSpotRiskTraderGroupsMenuComponent,
    static: true,
  })
  private traderGroupMenuComponent: BmarkSpotRiskTraderGroupsMenuComponent;
  private traderGroupMenuShownActionId;

  constructor(
    injector: Injector,
    protected benchmarkSummary: BmarkSummaryContainerComponent,
    benchmarkLookupService: BenchmarkDataPrimaryLookupService,
    hedgeLookupService: HedgeOrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, [benchmarkLookupService, hedgeLookupService], elementRef);
  }

  protected getMenuServiceType(): Type<BmarkSpotRiskContextMenuService> {
    return BmarkSpotRiskContextMenuService;
  }

  public showMenuAt(x: number, y: number): void {
    this.traderGroupMenuComponent.hideMenu();
    super.showMenuAt(x, y);
  }

  public hideMenu(): boolean {
    this.traderGroupMenuComponent.hideMenu();

    return super.hideMenu();
  }

  public selectedMenuItem(item: BfxBlotterOrdersContextMenuItem, event: PointerEvent) {
    if (!(event !== null && typeof event === "object" && event.isPrimary)) return;

    if (this.isItemEnabled(item)) {
      let menuService: BmarkSpotRiskContextMenuService = this
        .menuService as BmarkSpotRiskContextMenuService;
      menuService.fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        null,
        null,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }

  public onTraderGroupSelected(data: SelectedTraderGroupEvent): void {
    const traderGroupId: string =
      data !== null && typeof data === "object" && CubiqTS.Long.isLong(data.traderGroupId)
        ? data.traderGroupId.toString()
        : "";

    logger.out.info(
      `${this.constructor.name}.onTraderGroupSelected() traderGroupId: ${traderGroupId}`,
    );

    this.benchmarkSummary.activateHedgeMonitor(data.traderGroupId);
  }

  public showTraderGroups(event, contMenuRef, menuItem): void {
    if (
      !this.traderGroupMenuComponent.isVisible &&
      menuItem.actionId == BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO
    ) {
      let menuBoundingClientRef: any = contMenuRef.getBoundingClientRect();
      this.traderGroupMenuComponent.showMenuAt(menuBoundingClientRef, this);
    } else if (
      menuItem.actionId !== BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO &&
      this.traderGroupMenuComponent.isVisible
    ) {
      this.hideTraderGroups(menuItem);
    }
  }

  public hideTraderGroups(menuItem): void {
    this.traderGroupMenuComponent.hideMenu();
  }
}
